export default {
    VOLUNTEER_COORDINATOR: "Volunteer Coordinator"
};
  